import notificationBars from '@/notificationBars.json'

export const subscribeBox = notificationBars.subscribeBox || {}

export const DEFAULT_SUBSCRIBE_DESCRIPTION =
  'Blog sayfamıza abone olarak yeni içeriklerden haberdar olabilirsiniz! Üstelik abonelerimize özel hazırladığımız, perakende sektöründe dijitalleşme trendleriyle ilgili dokümana erişim ayrıcalığını da elde edersiniz.'

export const DEFAULT_SUBSCRIBE_DOWNLOAD_TEXT =
  'Teşekkürler!\n\nPerakende Sektöründe Dijitalleşme Trendleri dökümanını PDF olarak [bu bağlantıdan](https://uploads.mikro.com.tr/Perakende_Sektorunde_Dijitallesme_Trendleri_Mikroyazilim_79b4bf37dc.pdf) indirebilirsiniz.'
